export default {
  enterToSend: 'Press Enter to send',
  send: 'Send',
  noHistoryAvailable: 'No history available',
  deleteHistory: 'Delete History',
  listOfBookingSystems: 'List of Booking Systems',
}
